import { useState, useEffect, useContext } from "react";
import styles from "./profile.module.css";
import avatar from "illustrations/rana/rana-reading.webp";
import instance from "services/api";
import Spinner from "components/functional/spinner";
import tokenService from "services/token.service";
import { ToastService, ToastComponent } from "services/toast.service";
import { useTranslation } from "react-i18next";
import { MembershipContext } from "hoc/membership-data";

const Profile = () => {
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  });
  const membershipData = useContext(MembershipContext);
  const { membership, updateMembership } = membershipData;

  const { t } = useTranslation();
  const [isRunning, setIsRunning] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await instance.get(
          `users/${tokenService.getUserId()}`
        );
        setUser(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const savePreferences = async (e) => {
    e.preventDefault();
    setIsRunning(true);
    try {
      await instance.put(
        `users/${tokenService.getUserId()}/informations`,
        user
      );
      updateMembership({
        ...membership,
        first_name: user.first_name,
        last_name: user.last_name,
      });
      ToastService.showSuccessToast(t("parameters.profile.form.saved"));
    } catch (error) {
      console.error("Error saving user data:", error);
    } finally {
      setIsRunning(false);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <ToastComponent />
      <section className={styles.wrapper}>
        <div className={styles.content}>
          <img src={avatar} className={styles.avatar} alt="avatar" />
        </div>
        <form className={styles.form} onSubmit={savePreferences}>
          <section className={styles["form-content"]}>
            <div className="form-group">
              <label htmlFor="firstName">
                {t("parameters.profile.form.first-name")}
              </label>
              <input
                type="text"
                id="firstName"
                value={user.first_name}
                className={`${styles["team-input"]} ${styles.input}`}
                onChange={(e) =>
                  setUser({ ...user, first_name: e.target.value })
                }
                placeholder={t(
                  "parameters.profile.form.first-name-placeholder"
                )}
                data-testid="first-name-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">
                {t("parameters.profile.form.last-name")}
              </label>
              <input
                type="text"
                id="lastName"
                value={user.last_name}
                className={`${styles["team-input"]} ${styles.input}`}
                onChange={(e) =>
                  setUser({ ...user, last_name: e.target.value })
                }
                placeholder={t("parameters.profile.form.last-name-placeholder")}
                data-testid="last-name-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                {t("parameters.profile.form.email")}
              </label>
              <input
                type="email"
                id="email"
                value={user.email}
                className={`${styles["team-input"]} ${styles.input}`}
                disabled={true}
                placeholder={t("parameters.profile.form.email-placeholder")}
                data-testid="email-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">
                {t("parameters.profile.form.phone")}
              </label>
              <input
                type="tel"
                id="phone"
                value={user.phone_number || ""}
                className={`${styles["team-input"]} ${styles.input}`}
                onChange={(e) =>
                  setUser({ ...user, phone_number: e.target.value })
                }
                placeholder={t("parameters.profile.form.phone-placeholder")}
                data-testid="phone-input"
              />
            </div>
          </section>
          <div className={styles.actions}>
            <button
              type="submit"
              disabled={isRunning}
              className="btn btn--primary"
              data-testid="save-button"
            >
              {t("actions.save")}
              {isRunning && <Spinner className="action-loader"></Spinner>}
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default Profile;
